<template>
  <component :is="template" :spec="field.spec" :errors="aggregatedErrors" :saving="aggregatedSaving">

    <!-- секция ввода/выбора значения -->

    <template #editable>
      <component :is="referenceInput"
        :state="state"
        :field="field"
        v-model="modelProxy"
        @editing="inputEditing = $event"
        @errors="inputErrors = $event"
      />
    </template>

    <!-- секция только для чтения. тут грузим данные по ссылке -->

    <template #readonly>
      <async-component v-if="field.value !== null" :params="args" :asyncFunction="loadReference" #default="{ loading, error }">
        <content-spinner v-if="loading" class="ml2"/>
        <div v-else-if="error" class="ml2">{{ error }}</div>
        <span v-else-if="referenceField" class="ml2">
          {{ referenceField.value }}
        </span>
        <span v-else class="red ml2">
          не удается загрузить запись {{ field.value }}
        </span>
      </async-component>
    </template>

  </component>
</template>

<script>
import AsyncComponent from '@/components/AsyncComponent.vue'
import ContentSpinner from '@/components/ui/progress/ContentSpinner.vue'
import TenderInput from '@/components/common/form/reference/TenderInput.vue'
import WinnerInput from '@/components/common/form/reference/WinnerInput.vue'
import CompanyInput from '@/components/common/form/reference/CompanyInput.vue'
import ManagerInput from '@/components/common/form/reference/ManagerInput.vue'
import CurrencyInput from '@/components/common/form/reference/CurrencyInput.vue'
import ContractInput from '@/components/common/form/reference/ContractInput.vue'

import { DataService } from '@/services/DataService.js'

export default {
  components: {
    AsyncComponent,
    ContentSpinner,
    TenderInput,
    WinnerInput,
    CompanyInput,
    ManagerInput,
    CurrencyInput,
    ContractInput
  },
  props: ['entity', 'state', 'field', 'template', 'saving'],
  computed: {
    modelProxy: {
      get () { return this.field.value },
      set (v) { this.$emit('input', v) }
    },
    referenceInput () {
      // TODO: это, конечно, странный способ и странное место для всего этого...., но пока так
      switch (this.field.spec.name) {
        case 'tender_id':
          return 'TenderInput'
        case 'contract_id':
          return 'ContractInput'
        case 'counteragent_company_id':
          if ('tender_id' in this.state && this.state.tender_id.value) {
            return 'WinnerInput'
          } else {
            return 'CompanyInput'
          }
        case 'counteragent_user_id':
          return 'ManagerInput'
        case 'currency_id':
          return 'CurrencyInput'
        default:
          return ''
      }
    },
    aggregatedSaving () {
      return this.saving || this.inputEditing
    },
    aggregatedErrors () {
      return this.inputErrors || this.field.errors
    }
  },
  data () {
    return {
      inputEditing: false,
      inputErrors: null,
      referenceField: null,
      args: {
        id: this.entity.id,
        entity: this.entity.name,
        reference: this.field.spec.name
      },
      loadReference: async (args) => {
        return DataService.getReference(args)
          .then(({ data: { reference: field }, errors }) => {
            if (errors) {
              this.referenceField = null
            } else {
              this.referenceField = field
            }
          })
          .catch((e) => {
            this.referenceField = null
          })
      }
    }
  }
}
</script>
